export const SET_ALLOCATION = 'SET_ALLOCATION';
export const UPDATE_ALLOCATION = 'UPDATE_ALLOCATION';
